<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div>
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Купон #{{ $route.params.id }}<router-link class="button _free _second" to="/coupon">К списку</router-link></h1>
                </div>
                <form class="card">
                    <div class="inline">
                        <div class="grid">
                            <h3>Купон:</h3>
                            <div class="form-item">
                                <label for="coupon">Код</label>
                                <input type="text" id="coupon" class="text-input" v-model="data.code" />
                            </div>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="enabled" v-model="data.active" />
                                <label for="enabled">Активный</label>
                            </div>
                            <div class="text-item">
                                <span>Дата создания</span>
                                <p>{{ data.ctime }}</p>
                            </div>

                            <div class="text-item" v-if="data.date_start">
                                <span>Дата начала действия</span>
                                <DatePicker :value.sync="data.date_start"></DatePicker>
                            </div>

                            <div class="text-item" v-if="data.date_end">
                                <span>Дата окончания действия</span>
                                <DatePicker :value.sync="data.date_end"></DatePicker>
                            </div>

                            <div class="text-item" v-if="data.booking">
                                <span>Букинг</span>
                                <p><router-link :to="'/booking/'+data.booking.id">{{ data.booking.number }}</router-link></p>
                            </div>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="onetime" v-model="data.one_time" />
                                <label for="onetime">Одноразовый</label>
                            </div>
                            <div class="text-item">
                                <span>Кол-во использований</span>
                                <p>{{ data.times_count }}</p>
                            </div>
                            <div class="form-item">
                                <label for="timesmax">Макс. кол-во использований</label>
                                <input type="text" id="timesmax" class="text-input" v-model="data.times_limit" />
                            </div>
                            <div class="text-item">
                                <span>Тип купона</span>
                                <p>{{ data.type }}</p>
                            </div>
                            <div class="form-item">
                                <label for="type_use">Тип использования</label>
                                <select id="type_use" class="_wide" v-model="data.unique_general">
                                    <option value="1">Индивидуальный</option>
                                    <option value="2">Общий</option>
                                </select>
                            </div>
                            <div class="form-item checkbox disabled _no_opacity">
                                <input type="checkbox" id="used" v-model="data.used" />
                                <label for="used">Использован</label>
                            </div>
                            <div class="text-item" v-if="data.used_by">
                                <span>Использован юзером</span>
                                <p><router-link :to="'/users/'+data.used_by.id">{{ data.used_by.email }}</router-link></p>
                            </div>
                        </div>
                        <div class="grid">
                            <h3>Скидка:</h3>
                            <div class="form-item">
                                <label for="discount_type">Тип скидки</label>
                                <select id="discount_type" class="_wide" v-model="data.discount_type" @change="checkDiscount()">
                                    <option value="1">Процент</option>
                                    <option value="2">Сумма</option>
                                </select>
                            </div>
                            <div class="form-item">
                                <label for="max">Максимум</label>
                                <input type="text" id="max" class="text-input" v-model="data.discount_max" />
                            </div>
                            <div class="form-item">
                                <label for="current">Значение скидки</label>
                                <input type="text" id="current" class="text-input" v-model="data.discount_value" @blur="checkDiscount()" />
                            </div>
                            <div class="space"></div>
                            <div v-if="data.user">
                                <h3>Пользователь:</h3>
                                <div class="text-item">
                                    <span>Email</span>
                                    <p><router-link :to="'/users/' + data.user.id">{{ data.user.email }}</router-link></p>
                                </div>
                                <div class="text-item" v-if="data.user.dni">
                                    <span>DNI</span>
                                    <p>{{ data.user.dni }}</p>
                                </div>
                                <div class="text-item" v-if="data.user.phone">
                                    <span>Телефон</span>
                                    <p>{{ data.user.phone }}</p>
                                </div>
                                <UserPicker :user.sync="data.user" @changeUser="changeUser"></UserPicker>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>
            </div>
            <div class="page-load" v-show="data_status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import DatePicker from '@/components/DatePicker.vue'
    import UserPicker from '@/components/UserPicker.vue'

    export default {
        components: {
            Header,
            DatePicker,
            UserPicker
        },
        data () {
            return {
                data: {},
                data_backup: false,
                data_status: 'init',
                status_request: '',
            }
        },
        computed: {
            showButton () {
                if (JSON.stringify(this.data) == this.data_backup) {
                    return false
                }
                return true
            }
        },
        created () {
            this.getData()
        },
        methods: {
            changeUser (user) {
                this.data.user = user
                this.update()
            },
            checkDiscount () {
              if (this.data.discount_type == 1 && this.data.discount_value > 100) this.data.discount_value = 100
            },
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            solve () {
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/feedback/' + this.$route.params.id + '/solve')
                        .then(() => {
                            this.status_request = ''
                            this.data.solved = true
                            resolve()
                        })
                        .catch(() => {
                            this.status_request = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/coupon/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/coupon')
                        })
                })
            },
            update () {
                let json = JSON.stringify(this.data)
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/coupon/' + this.$route.params.id, json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        this.status_request = ''
                        this.savedata()
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.status_request = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
        }
    }
</script>
